<div class="ui container">
  <div class="ui breadcrumb">
    <a [routerLink]="['/']">
      Bounties List
    </a>
    <i class="right angle icon divider"></i>
    <a [routerLink]="bounty ? ['/bounties/' + bounty.id] : null">
      View Bounty
    </a>
    <i class="right angle icon divider"></i>
    <div class="active section">Create Bounty</div>
  </div>

  <h1>Edit bounty</h1>
  <div *ngIf="!bounty" class="ui basic very padded segment">
    <div class="ui inverted active centered inline huge text loader">
      Loading bounty...
    </div>
  </div>

  <div class="ui inverted padded segment section" *ngIf="bounty">
    <div class="ui active dimmer" *ngIf="submitting">
      <div class="ui indeterminate text loader">
        Saving Bounty...
      </div>
    </div>

    <form class="ui inverted form" [formGroup]="form" (submit)="submitForm()">
      <div class="field">
        <label>Bounty Type</label>
        <span class="ui large label" [ngClass]="labelClass">
          {{ bounty.type }}
        </span>
      </div>
      <div class="field">
        <label>Game mode</label>
        <sui-select class="selection" formControlName="gameMode"
          [class.error]="hasError('gameMode')">
          <sui-select-option *ngFor="let mode of gameModes"
            [value]="mode">
          </sui-select-option>
        </sui-select>
      </div>

      <app-beatmap-goals-fields *ngIf="bounty.type === 'beatmap'"
        [parentForm]="form" [submitFailed]="submitFailed"
        [bounty]="bounty"></app-beatmap-goals-fields>
      <div *ngIf="bounty.type === 'tournament'">
        <!-- Tournament goal -->
        <div class="grouped fields">
          <div class="field">
            <label>Tournament name</label>
            <input class="ui input" [class.error]="hasError('tournamentName')"
              type="text" placeholder="osu! World Cup (Standard)"
              formControlName="tournamentName">
          </div>

          <div class="field">
            <label>Place required to achieve (First place = 1)</label>
            <input class="ui input" type="number" placeholder="1"
              [class.error]="hasError('tournamentPlace')"
              formControlName="tournamentPlace">
          </div>
        </div>
      </div>
      <app-general-fields [parentForm]="form" [submitFailed]="submitFailed"
        [bounty]="bounty">
      </app-general-fields>

      <div class="field">
        <sui-checkbox formControlName="addDuration">
          <p>Change bounty duration (end date)</p>
        </sui-checkbox>
      </div>

      <div class="field" *ngIf="form.get('addDuration').value === true">
        <label>Select number of days (from now) that bounty should end on:</label>
        <sui-select class="selection" formControlName="duration"
          [class.error]="hasError('duration')" [options]="durationOptions"
          labelField="name" #select>
          <sui-select-option *ngFor="let option of select.filteredOptions"
            [value]="option">
          </sui-select-option>
        </sui-select>
      </div>

      <div class="ui relaxed grid section">
        <div class="four wide column">
          <button type="submit" class="ui large fluid green button"
            [class.loading]="submitting">
            Save
          </button>
        </div>
        <div class="sixteen wide column">
          <div *ngIf="errors" class="ui inverted red segment">
            <h4 class="header">
              There were some errors with your submission
            </h4>
            <ul class="list">
              <li *ngFor="let error of errors">{{error}}</li>
            </ul>
          </div>
        </div>
      </div>
    </form>


  </div>
</div>
